import { Controller } from "@hotwired/stimulus";
import { log } from "../../javascript/utils/logger";
import ClipboardJS from "clipboard/dist/clipboard.min.js";

export default class extends Controller {
  connect() {
    log("copy button connect", this)
    this.copyButton = new ClipboardJS(this.element)
    this.copyButton.on("success", () => {
      Stoked.toast("Copied!")
    })
    this.element.addEventListener("click", this.stopPropagation)
  }

  stopPropagation = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  disconnect() {
    log("copy button disconnect")
    this.element.removeEventListener("click", this.stopPropagation)
    this.copyButton.destroy()
  }
}
